import React from 'react'
import { SliderItemStyle } from './style'
import { useDispatch } from 'react-redux'
import ItemPreview from 'components/ItemPreview'
import { removeItemFlowReq } from 'components/Steps/thunk'

const SliderItem = ({
	item = {},
	itemExchange = {},
	imageUrl,
	isExchangeVariant,
	...props
}) => {
	const { name, orderId, orderItemId, price, attributes, flow } = item

	const dispatch = useDispatch()
	const handlerSliderItem = () => {
		dispatch(
			removeItemFlowReq({
				flow,
				orderItemId,
				orderId,
			})
		)
	}

	return (
		<SliderItemStyle {...props}>
			<ItemPreview
				price={price}
				name={name}
				currency={item.currency}
				attributes={attributes}
				imageUrl={imageUrl}
				orderId={orderId}
				orderItemId={orderItemId}
				isExchangeVariant={isExchangeVariant}
				flow={flow}
				onRemoveAction={handlerSliderItem}
				cartView
			/>
		</SliderItemStyle>
	)
}
export default SliderItem
